import NotesAchievedModule from './containers/notesAchievedModule'

export {default as NotesAchievedModuleLayout} from './components/notesAchievedModuleLayout'

export default NotesAchievedModule
